import { FC, memo } from 'react'
import { useFormContext } from '../forms/form'
import FieldError, { useFieldValidity } from './fieldError'

interface TextAreaInputProps {
    label: string
    value: string
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
    placeholder?: string
    rows?: number
    required?: boolean
    maxLength?: number
    showCharacterCount?: boolean
    helperText?: string
}

const TextAreaInput: FC<TextAreaInputProps> = ({ label, value, onChange, placeholder, rows = 3, required, maxLength, showCharacterCount = true, helperText }) => {
    const { disableInputs, isLoading } = useFormContext()
    const { errorMessage, fieldClassName, onBlur, onChange: onValidityChange, onInvalid } = useFieldValidity()

    return (
        <div className="input-holder w-full sm:max-w-none md:w-[min(100%,calc(theme(maxWidth.64)*2+theme(spacing.4)))] md:max-w-[min(100%,calc(theme(maxWidth.64)*2+theme(spacing.4)))]">
            <label>{label}{required ? '*' : ''}</label>
            <textarea
                value={value}
                placeholder={placeholder}
                onChange={(e) => {
                    onValidityChange(e)
                    onChange(e)
                }}
                onBlur={onBlur}
                onInvalid={onInvalid}
                rows={rows}
                required={required}
                disabled={disableInputs}
                className={`${fieldClassName} ${isLoading ? 'animate-pulse' : ''}`}
                maxLength={maxLength}
            />
            <FieldError message={errorMessage} />
            {showCharacterCount && maxLength && (
                <div className="text-xs text-gray-500 mt-1">
                    {value.length}/{maxLength} characters
                </div>
            )}
            {helperText && (
                <div className="text-xs text-gray-500 mt-1">
                    {helperText}
                </div>
            )}
        </div>
    )
}

export default memo(TextAreaInput)

